<template>
  <div>
    <div class="flex flex-row flex-wrap">
      <div class="-mx-1 py-1" v-if="tags.length > 0">
        <span
          class="inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1 text-sm bg-blue-100 text-blue-700 m-1"
          v-for="(tag, key) in tags"
          v-bind:key="key"
        >
          {{ tag }}
          <button
            type="button"
            class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-blue-400 hover:bg-blue-200 hover:text-blue-500 focus:outline-none focus:bg-blue-500 focus:text-white"
            v-on:click="removeTag(key)"
          >
            <span class="sr-only">Remove large option</span>
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
      </div>
    </div>
    <div class="mt-1 relative">
      <input
        :id="resId"
        type="text"
        class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        v-model="input"
        v-on:input="processTags($event.target.value)"
        v-on:keydown.tab.prevent="processTagsOnKeyUpEvent($event.target.value)"
        v-on:keydown.enter.prevent="
          processTagsOnKeyUpEvent($event.target.value)
        "
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "TagInput",
  props: {
    resId: {
      type: String
    },
    tags: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      input: null
    };
  },
  methods: {
    processTags(value) {
      if (value.length > 0 && value.indexOf(",") > -1) {
        let tags = value.split(",");
        console.log(tags);

        // tags.forEach(tag => {
        //   if (tag.length > 0) {
        //     this.emailDomains = this.addIfUnique(
        //       this.emailDomains,
        //       this.parsedTag(tag)
        //     );
        //   }
        // });
      }
    },
    processTagsOnKeyUpEvent(value) {
      if (!value.replace(/\s/g, "").length) return;
      if (value.length > 0) {
        this.addIfUnique(value);
      }
    },
    removeTag(index) {
      this.tags = this.tags.splice(index, 1);
    },
    hasDuplicates(arr, addVal) {
      const findDups = arr.filter(
        (item, index) => item.toLowerCase() == addVal.toLowerCase()
      );
      if (findDups.length > 0) return true;
      return false;
    },
    addIfUnique(value) {
      if (!this.hasDuplicates(this.tags, value)) {
        this.tags.push(value);
      }
      this.input = null;
    }
  }
};
</script>
